var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.buttonClass,attrs:{"depressed":""},on:{"click":_vm.clickTime}},[_vm._v(_vm._s(_vm.simpleTime(_vm.time)))])}
var staticRenderFns = []

export { render, staticRenderFns }